import { render, staticRenderFns } from "./cont2.vue?vue&type=template&id=1b3c1f0b&scoped=true"
var script = {}
import style0 from "./cont2.vue?vue&type=style&index=0&id=1b3c1f0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c1f0b",
  null
  
)

export default component.exports